<div class="tw-px-4" [ngClass]="{'tw-mt-6 tw-max-w-[700px] tw-mx-auto': advancedDeal}">
    <!-- ACTIVE DEALS APPROVALS VIEW -->
    <div class="tw-my-4">
      @if(advancedDeal) {
        <h2>Approvals</h2>
      } @else {
         <h3>Approvals</h3>
      }

      @if(approvalsLoading) {
        <mat-spinner diameter="24" class="loading-options"></mat-spinner>
        <div class="loading-text"> Loading Approvals...</div>
      } @else {
        @if( approvals?.length ) {
          <mat-accordion>
            @for( approval of approvals; track $index ) {
              @if( canSeeFunctionalApprovals || approval.calculationType === 'sba' ) {
                <app-functional-approval
                  [approval]="approval"
                  [hideCreateOptionButton]="deal.stage === 'inactive' || deal.stage === 'funded'"
                  [canRecommend]="canRecommendOptions && deal.stage !== 'funded' && deal.stage !== 'inactive'"
                />
              } @else {
                <app-approval-smart
                  [readOnly]="readOnly"
                  [approvalsCount]="approvals.length"
                  [approval]="approval"
                  [useStoreApprovals]="false"
                  [hideCreateOptionButton]="deal.stage === 'inactive' || deal.stage === 'funded'"
                  [canRecommend]="canRecommendOptions && deal.stage !== 'funded' && deal.stage !== 'inactive'"
                ></app-approval-smart>
              }

              @if( offerOptions?.length ) {

                @for( option of offerOptions; track $index ) {

                  @if( option.approvalId === approval.id ) {

                    <offer-option [option]="option"
                                  [optionType]="'approval'"
                                  [cardExpandable]="true"
                                  [hasContractRequest] = "hasContractRequest"
                    />

                  }

                }

              }

            }

          </mat-accordion>
        } @else {
          <div class="no-offers tw-pt-10">No Approvals Yet</div>
        }

      }

    </div>

    <app-offer-smart
      [dealId]="deal.id"
      [dealStage]="deal.stage"
      [dealStatus]="deal.status"
      [loanProductType]="deal.loan_product.type"
      [readOnly]="readOnly"
      [hasContractRequest]="hasContractRequest"
      [advancedDeal]="advancedDeal"
    >
    </app-offer-smart>

  </div>